module.exports = __webpack_public_path__ + "img/gh.e96689f2.png";